import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { Section } from "@/components/app/Primitives";
import { AdapterCard } from "@/components/engage/AutoFetchPanel";
import { WebhookPanel } from "@/components/engage/WebhookPanel";
import { ResultBadge } from "@/components/engage/ResultBadge";

const HOME = { ey_auditor: "/ey", procurement_desk: "/procurement", customer: "/customer", propay_admin: "/admin" };

export default function AutoFetchMonitor() {
  const { user } = useAuth();
  const [adapter, setAdapter] = useState(null);
  const [runs, setRuns] = useState([]);
  const [busy, setBusy] = useState(false);
  const home = HOME[user?.role] || "/admin";
  const load = async () => { const [a, r] = await Promise.all([api.get("/autofetch/status"), api.get("/autofetch/runs?limit=40")]); setAdapter(a.data); setRuns(r.data); };
  useEffect(() => { load(); }, []);
  const sync = async (fail) => {
    setBusy(true);
    try { const r = await api.post("/autofetch/sync", fail ? { simulate_failure: true } : {}); r.data.status === "error" ? toast.error(r.data.error) : toast.success(`Tenant-wide sync: ${r.data.received} received · ${r.data.accepted} accepted · ${r.data.rejected} rejected`); await load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Sync failed"); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-6" data-testid="autofetch-monitor">
      <Section title="Auto Fetch / Integration Monitor" subtitle="Adfluence content ingestion adapter — every record keeps its raw payload, normalised PoE and accept/reject reason." />
      <AdapterCard adapter={adapter} busy={busy} onSync={() => sync(false)} onFail={() => sync(true)} />
      <WebhookPanel onIngested={load} />
      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
        <div className="px-5 py-3 border-b border-slate-100 text-sm font-semibold text-slate-800">Sync history ({runs.length})</div>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-[11px] uppercase tracking-wider text-slate-500"><tr><th className="px-4 py-2">Started</th><th className="px-4 py-2">Scope</th><th className="px-4 py-2">By</th><th className="px-4 py-2">Result</th><th className="px-4 py-2 text-right">Received</th><th className="px-4 py-2 text-right">Accepted</th><th className="px-4 py-2 text-right">Rejected</th><th className="px-4 py-2">Error</th></tr></thead>
          <tbody>
            {runs.map((r) => (
              <tr key={r.id} className="border-t border-slate-100" data-testid={`monitor-run-${r.id}`}>
                <td className="px-4 py-2 font-mono text-xs">{new Date(r.started_at).toLocaleString()}</td>
                <td className="px-4 py-2 text-xs">{r.campaign_id ? <Link className="text-[#0052FF] hover:underline" to={`${home}/campaigns/${r.campaign_id}?tab=deliverables`}>campaign</Link> : "tenant-wide"}</td>
                <td className="px-4 py-2 text-xs">{r.started_by}</td>
                <td className="px-4 py-2"><ResultBadge value={r.status === "success" ? "PASS" : "FAIL"} /></td>
                <td className="px-4 py-2 text-right font-mono">{r.received}</td><td className="px-4 py-2 text-right font-mono">{r.accepted}</td><td className="px-4 py-2 text-right font-mono">{r.rejected}</td>
                <td className="px-4 py-2 text-xs text-rose-700">{r.error || ""}</td>
              </tr>
            ))}
            {runs.length === 0 && <tr><td colSpan={8} className="px-4 py-6 text-center text-slate-400">No syncs yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
